import ASSET from 'constants/asset-types';

export const isAudioContentType = ({ contentType } = {}) => contentType === ASSET.contentType.audio;

export const isVideoContentType = ({ contentType } = {}) => contentType === ASSET.contentType.video;

export const isEbookContentType = ({ contentType } = {}) => contentType === ASSET.contentType.ebook;

export const isPDFEbookType = (queueItem) => {
  const { mediaType, contentType, downloadType } = queueItem ?? {};
  return (
    isEbookContentType({ contentType }) &&
    downloadType === ASSET.downloadType.fileUrl &&
    mediaType === ASSET.mediaType.pdf
  );
};

export const isLCPEbookType = (queueItem) => {
  const { mediaType, contentType, downloadType } = queueItem ?? {};
  return (
    isEbookContentType({ contentType }) &&
    downloadType === ASSET.downloadType.fileUrl &&
    mediaType === ASSET.mediaType.readiumLCP
  );
};

export const isPubhubEbookType = (queueItem) => {
  const { mediaType, contentType, downloadType } = queueItem ?? {};
  return (
    isEbookContentType({ contentType }) &&
    downloadType === ASSET.downloadType.fileUrl &&
    mediaType === ASSET.mediaType.epubZip
  );
};
